import styled from "styled-components";
import Heading from "../heading/Heading";
import colors from "../../tokens/colors";
import { pxToRem } from "@input-output-hk/px-to-rem";

export const ContributePageTitle = styled(Heading)`
  display: flex;
  align-items: center;
  color: ${colors.primary.slateGrey};
  font-size: ${pxToRem(32)};
  line-height: ${pxToRem(44)};
  font-weight: 600;
`;
